import { Box } from '@ublend-npm/aulaui-core';
import React from 'react';
import AssignmentCard from '../AssignmentCard/AssignmentCard';

type Props = {
  spaceId: string;
};

const AssignmentList = ({ spaceId }: Props) => {
  return (
    <Box>
      <AssignmentCard spaceId={spaceId} />
    </Box>
  );
};

export default AssignmentList;
